import styles from './Footer.module.css'
import { FaGithub, FaEnvelope } from 'react-icons/fa'

function Footer() {
    return (
        <div className={styles.container}>
            <div className={styles.titulo}>
                LABORATORIO DE ENGENHARIA DE SOFTWARE
            </div>

            <div className={styles.contato}>
                <p className={styles.contatoName}> Contato </p>

                <FaGithub className={styles.icon} size={32} data-testid="github-icon" />
                <FaEnvelope className={styles.icon} size={32} data-testid="email-icon" />
            </div>

            <div className={styles.endereco}> 
                <p data-testid="cidade"> Piripiri-PI 64260-000 </p> <br />
                <p data-testid="universidade">Universidade Estadual do Piauí</p> <br />
                <p data-testid="campus">Campus Prof. Antônio Giovani Alves de Sousa</p> <br />
            </div>
        </div>
    );
}
export default Footer; 